import { RESPONSEDATA } from "app/shared/services/services-model.type";
import {
  FETCH_TERM_DEPOSIT_STATEMENT_REQUEST,
  FETCH_TERM_DEPOSIT_STATEMENT_SUCCESS,
  FETCH_TERM_DEPOSIT_STATEMENT_FAILURE,
  FETCH_TERM_DEPOSIT_STATEMENT_AUTHORIZATION_KEY_FAILURE,
  FETCH_TERM_DEPOSIT_STATEMENT_AUTHORIZATION_KEY_REQUEST,
  FETCH_TERM_DEPOSIT_STATEMENT_AUTHORIZATION_KEY_SUCCESS,
  FETCH_TERM_DEPOSIT_STATEMENT_CONFIRM_FAILURE,
  FETCH_TERM_DEPOSIT_STATEMENT_CONFIRM_REQUEST,
  FETCH_TERM_DEPOSIT_STATEMENT_CONFIRM_SUCCESS,
  FETCH_TERM_DEPOSIT_STATEMENT_CREATE_FAILURE,
  FETCH_TERM_DEPOSIT_STATEMENT_CREATE_REQUEST,
  FETCH_TERM_DEPOSIT_STATEMENT_CREATE_SUCCESS,
  SET_TERM_STATEMENT_STORE,
  SET_TERM_STATEMENT_RESET,
} from "./actions.type";
import {
  FetchTermDepositListStatementRequest,
  FetchTermDepositListStatementSuccess,
  FetchTermDepositListStatementFailure,
  FetchTermDepositStatementCreateRequest,
  FetchTermDepositStatementCreateSuccess,
  FetchTermDepositStatementCreateFailure,
  FetchTermDepositStatementConfirmRequest,
  FetchTermDepositStatementConfirmSuccess,
  FetchTermDepositStatementConfirmFailure,
  FetchTermDepositStatementAuthorizationRequest,
  FetchTermDepositStatementAuthorizationSuccess,
  FetchTermDepositStatementAuthorizationFailure,
  DataTermDepositStatement,
  SetTermStatementStore,
  SetTermStatementReset,
  TermDepositStatementState,
} from "./types";

export const fetchTermDepositListStatementRequest = (payload?: string): FetchTermDepositListStatementRequest => ({
  type: FETCH_TERM_DEPOSIT_STATEMENT_REQUEST,
  payload,
});

export const fetchTermDepositListStatementSuccess = (payload?: RESPONSEDATA): FetchTermDepositListStatementSuccess => ({
  type: FETCH_TERM_DEPOSIT_STATEMENT_SUCCESS,
  payload,
});

export const fetchTermDepositListStatementFailure = (payload?: string): FetchTermDepositListStatementFailure => ({
  type: FETCH_TERM_DEPOSIT_STATEMENT_FAILURE,
  payload,
});

export const fetchTermDepositStatementCreateRequest = (payload?: DataTermDepositStatement): FetchTermDepositStatementCreateRequest => ({
  type: FETCH_TERM_DEPOSIT_STATEMENT_CREATE_REQUEST,
  payload,
});

export const fetchTermDepositStatementCreateSuccess = (payload?: RESPONSEDATA): FetchTermDepositStatementCreateSuccess => ({
  type: FETCH_TERM_DEPOSIT_STATEMENT_CREATE_SUCCESS,
  payload,
});

export const fetchTermDepositStatementCreateFailure = (payload?: string): FetchTermDepositStatementCreateFailure => ({
  type: FETCH_TERM_DEPOSIT_STATEMENT_CREATE_FAILURE,
  payload,
});

export const fetchTermDepositStatementConfirmRequest = (payload?: RESPONSEDATA): FetchTermDepositStatementConfirmRequest => ({
  type: FETCH_TERM_DEPOSIT_STATEMENT_CONFIRM_REQUEST,
  payload,
});

export const fetchTermDepositStatementConfirmSuccess = (payload?: RESPONSEDATA): FetchTermDepositStatementConfirmSuccess => ({
  type: FETCH_TERM_DEPOSIT_STATEMENT_CONFIRM_SUCCESS,
  payload,
});

export const fetchTermDepositStatementConfirmFailure = (payload?: string): FetchTermDepositStatementConfirmFailure => ({
  type: FETCH_TERM_DEPOSIT_STATEMENT_CONFIRM_FAILURE,
  payload,
});

export const fetchTermDepositStatementAuthorizationRequest = (
  payload?: RESPONSEDATA,
  code?: string,
): FetchTermDepositStatementAuthorizationRequest => ({
  type: FETCH_TERM_DEPOSIT_STATEMENT_AUTHORIZATION_KEY_REQUEST,
  payload,
  code,
});

export const fetchTermDepositStatementAuthorizationSuccess = (payload?: RESPONSEDATA): FetchTermDepositStatementAuthorizationSuccess => ({
  type: FETCH_TERM_DEPOSIT_STATEMENT_AUTHORIZATION_KEY_SUCCESS,
  payload,
});

export const fetchTermDepositStatementAuthorizationFailure = (
  payload?: boolean,
  msg?: string,
): FetchTermDepositStatementAuthorizationFailure => ({
  type: FETCH_TERM_DEPOSIT_STATEMENT_AUTHORIZATION_KEY_FAILURE,
  payload,
  msg,
});

export const setTermStatementStore = (payload?: TermDepositStatementState): SetTermStatementStore => ({
  type: SET_TERM_STATEMENT_STORE,
  payload,
});

export const setTermStatementReset = (): SetTermStatementReset => ({
  type: SET_TERM_STATEMENT_RESET,
});
